/* eslint-disable no-undef */
import React, { useEffect, useState, Fragment, useContext } from 'react';
import { useSelector, connect } from 'react-redux';
import LocaleContext from 'constants/localization';
import API from 'constants/api';
import { setStatementText } from 'actions/modalActions';

const StatementTextModal = ({ resource, setStatementText }) => {
  const LS = useContext(LocaleContext);
  const [statementTexts, setStatementTexts] = useState([]);
  
  useEffect(() => {
    getTexts();
  },[]);
  
  const getTexts = () => {
    let url = API.CE + '/statementTexts';
    
    return fetch(url, {
    })
      .then(res => res.json())
      .then(result => {
	    const texts = [...result];
	    setStatementTexts(texts);
      });
  };
  

  return (
    <div>
    {statementTexts.length > 0 &&
       <div className='statementTextWrapper'>
       	{
		  statementTexts.map(text => (
		      <div className='statementTextField'>
		        <div
		        key={text}
		        onClick={() => setStatementText(text)}>
		        {text.split("\n").map(function(item) {
				  return (
				    <span>
				      {item}
				      <br/>
				    </span>
				  )
				})}</div>
		        <hr/>
		      </div>
	      ))
	     }
      </div>
     }
     {statementTexts.length == 0 &&
      <p>{LS.statement.noPresetStatementTexts}</p>
     }
    </div>
  );
};

export default connect(null, { setStatementText })(StatementTextModal);